import React, {useState, useEffect} from 'react';
import { List } from 'antd';
import{addVisitLog, history} from 'libs';
import styles from '../layout.module.less'
import defaultPicture from './default-picture.png'
import titleImg from './title.png'
import hotImg from './hot_seller.png'
import hotPrice from './hot_price.png'
import hotBg from './hot_bg.png'

import {observer} from "mobx-react";
import store from '../store'
import cartStore from "../../cart/store"

// the hook
import { useTranslation } from 'react-i18next';

export default observer(function (props) {
  const { t, i18n } = useTranslation();

  useEffect(()=>{
    store.fetchCampaignRecords();
  },[])

  //加入购物车
  const handleBuy = (v,record = {}, isBuy = true) => {
    v.stopPropagation();
    let eventCode = 'BannerProductListRent';
    let eventName = '产品列表租';
    if (isBuy) {
      eventCode = 'BannerProductListSale';
      eventName = '产品列表买';
    }
    addVisitLog({
      pageName: eventName,
      fromPageUrl: window.referrerUrl,
      pageUrl:`${window.location.origin}${history.location.pathname}`,
      eventCode: eventCode,
      eventName: eventName,
    })
    cartStore.addRecord(record.id, isBuy ? record.saleCatalog : record.leaseCatalog ).then(v => true)
  }

  const goDetail = (id)=>{
    addVisitLog({
      pageName: '查看banner产品详情',
      fromPageUrl: history.location.pathname,
      pageUrl:`${window.location.origin}/goods/detail?id=${id}`,
      eventCode: 'BannerProductDetail',
      eventName: "查看banner产品详情",
    })
    window.open('/goods/detail?id=' + id,'_blank')
  }

  return (
    <React.Fragment>
      <div className={styles.hotSellerContainer}>
        <div className={styles.campaign_info}>
          <img style={{width:'100%'}} src={titleImg} alt="" />
          {/* <div className={styles.campaign_title}>
            <div>{t('临床器材爆款')}</div>
            <div className={styles.campaign_line}>
              <span className={styles.common_ine1}></span>
              <span className={[styles.common_ine1, styles.common_ine2].join(' ')}></span>
            </div>
          </div>
          <div className={styles.campaign_subtitle}>{t('一站式服务，等你来询！')}</div> */}
          {/* <div className={styles.campaign_desc}>
             <div className={styles.campaign_desc_left}>
                <img src={ hotImg } className={styles.hotImg}/>
             </div>
             <div className={styles.campaign_desc_right}>
                <div className={styles.campaign_desc_title}>{t('常温低速离心机')}</div>
                <div className={styles.campaign_desc_price}>
                  <div className={styles.price}>
                    <div className={styles.price_num}>
                      <span className={styles.price_unit}>¥</span>
                      <span>1999</span>
                    </div>
                    <div className={styles.spec}>月/台(起)</div>
                  </div>
                  <img src={hotPrice} className={styles.hotPrice_img}/>
                </div>
                <div className={styles.join_btn_wrapper}>
                  <div className={styles.join_btn}>{t('立即加购')}</div>
                </div>
             </div>
          </div> */}
        </div>
          <div className={styles.campaign_list}>
            <List
              className={styles.list}
              header=''
              footer=''
              // grid={{column: 4, gutter: 20}}
              // dataSource={store.records}
              dataSource={store.bannerRecords}
              split={false}
              pagination={false}
              loading={store.isFetching}
              renderItem={(item, index) => (
                <List.Item>
                  <div key={'goods' + item['id']} style={{cursor:'pointer'}} className={[styles.item].join(" ")} title={item['name']} onClick={() => {
                      goDetail(item['id']);
                    }}>
                      <div className={styles.item_left}>
                      { item?.thumb ? <img src={item.thumb} /> : <img src={defaultPicture} className={styles.main_img}/>}
                      </div>
                      <div className={styles.item_right}>
                        <div className={styles.item_right_title}>
                          <span className={styles.name}>{item['name']}</span>
                          <span className={styles.tag}>{item['stockNumber']}</span>
                        </div>
                        {
                         item['des'] ? (
                            <div className={styles.item_right_des}>
                              {item['des']}
                            </div>
                          ) : <div className={styles.item_right_empty}>
                            </div>
                        }
                        <div className={styles.item_right_price}>
                          {item['bannerPrice']}
                        </div>
                        <div className={styles.item_right_spec}>
                          {item['bannerUnit']}
                        </div>
                        <div className={styles.btnGroup}>
                          {
                            item['leaseAble'] ? (
                              <a className={styles.btn1} loading={cartStore.addCartLoading} onClick={v => handleBuy(v,item, false)}>{t('租赁')}</a>
                            ) : ''
                          }
                          {
                            item['saleAble'] ? (
                              <a className={styles.btn2} loading={cartStore.addCartLoading} onClick={v => handleBuy(v,item, true)}>{t('采购')}</a>
                            ) : ''
                          }
                        </div>
                      </div>
                  </div> 

                </List.Item>
              )}
            />
          </div>
          <div className={styles.campaign_tips}>
            <span className={styles.import_icon}>*</span>
          现货库存机器租赁抢订中，可单月起租，不满1年租期需额外支付运费。部分二手机器可以出售，详情咨询：15000571844
          </div>
          <img src={hotBg} className={styles.hot_bg}/>
      </div>

    </React.Fragment>
  )

})

